import { gql } from "@apollo/client";

export const REMOVE_SPACE_MEMBERSHIP = gql`
  mutation RemoveSpaceMembership($input: RemoveSpaceMembershipInput!) {
    removeSpaceMembership(input: $input)
  }
`;
